import type { BusinessCategoryConfig, BusinessCategoryKind } from '@/types/business-category'

export const businessCategoryConfigs: Record<BusinessCategoryKind, BusinessCategoryConfig> = {
  gift: { kind: 'gift', giftType: 1, label: '平替区', requiresCompany: true },
  explosive: { kind: 'explosive', giftType: 2, label: '限量购', requiresCompany: true },
  superior: { kind: 'superior', giftType: 3, label: '中赢商品', requiresCompany: true },
  district: { kind: 'district', giftType: 4, label: '零元购', requiresCompany: true },
  star: { kind: 'star', giftType: 5, label: '9.9元商品', requiresCompany: true },
}

export function isBusinessCategoryKind(value: unknown): value is BusinessCategoryKind {
  return typeof value === 'string' && value in businessCategoryConfigs
}
